import SubcategoryPage from '@/components/template/SubcategoryPage';

const Compasso = () => {
  const products = [
    {
      title: "Compasso Classic",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80",
      url: "/proizvodi/compasso-classic"
    },
    {
      title: "Compasso Modern",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80",
      url: "/proizvodi/compasso-modern"
    },
    {
      title: "Compasso Premium",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80",
      url: "/proizvodi/compasso-premium"
    },
    {
      title: "Compasso Luxury",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/compasso-luxury"
    },
    {
      title: "Compasso Minimal",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/compasso-minimal"
    },
    {
      title: "Compasso Elite",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/compasso-elite"
    }
  ];

  return (
    <SubcategoryPage
      title="Compasso"
      description="Edinstveni izdelki Compasso, ki združujejo dizajn in funkcionalnost za sodoben dom."
      heroImage="https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Compasso;